import { createFileRoute, stripSearchParams } from "@tanstack/react-router";
import { Suspense } from "react";
import { hasOrgPermission } from "@/app/capabilities/api/check-permission";
import { orgCapabilitiesQueryOptions } from "@/app/capabilities/api/get-capabilities";
import { ORG } from "@/app/capabilities/permissions";
import { orgMembersQueryOptions } from "@/app/org-members/api/get-org-members";
import {
  orgMembersSearchDefaults,
  orgMembersSearchSchema,
} from "@/app/org-members/search";
import { OrganizationPageSkeleton } from "@/app/organizations/components/organization-page-skeleton";
import { OrganizationOverviewPage } from "@/app/organizations/page";
import { requireOneOfOrgPermission } from "@/lib/route-guards";

export const Route = createFileRoute(
  "/_authenticated/orgs/$organizationId/projects/$projectId/organization/"
)({
  validateSearch: orgMembersSearchSchema,
  search: {
    middlewares: [stripSearchParams(orgMembersSearchDefaults)],
  },
  beforeLoad: async (ctx) => {
    // The page renders org metadata and org members as independently gated
    // sections; allow the route when the caller can read either one.
    await requireOneOfOrgPermission(ctx, [
      ORG.orgMetadata.read,
      ORG.members.read,
    ]);

    const { queryClient } = ctx.context;
    const { organizationId } = ctx.params;
    const capabilities = await queryClient.ensureQueryData(
      orgCapabilitiesQueryOptions(organizationId)
    );

    if (hasOrgPermission(capabilities.authz, ORG.members.read)) {
      queryClient.prefetchQuery(
        orgMembersQueryOptions({
          organizationId,
          limit: ctx.search.limit,
          offset: ctx.search.offset,
        })
      );
    }
  },
  loader: () => ({
    crumb: "Organization",
  }),
  component: () => (
    <Suspense fallback={<OrganizationPageSkeleton />}>
      <OrganizationOverviewPage />
    </Suspense>
  ),
});
